module.exports = __webpack_public_path__ + "557c177ede797411633712f6aecaed8f.svg";